import React, { Fragment, ReactElement } from "react";
import { PaginationProps } from "../../Pagination";

interface MobileTableProps {
  rows: Array<any>;
  MobileRow?: (row: any) => JSX.Element;
  noDataPlaceholder?: string | ReactElement;
  pagination: PaginationProps;
}

export const MobileViewTable = ({
  rows,
  MobileRow,
  noDataPlaceholder = <></>,
}: MobileTableProps) => {
  return (
    <div
      className="min-w-full border-separate relative flex flex-col sm:gap-y-3"
      style={{ borderSpacing: 0 }}
    >
      {rows?.length > 0
        ? rows.map((r, rIndex) => (
            <Fragment key={rIndex}>{MobileRow?.(r)}</Fragment>
          ))
        : noDataPlaceholder}
    </div>
  );
};
